<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="formUserSearch"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />
        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handleSearchClick(searchPayload)" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptions"
                          @goClick="handleOrderByClick" />
            </div>
        </div>
        <data-list :dataCols="formUserCols"
                   :dataListItems=" formUserList"
                   :tableClass="'table table-striped table-sm'" />

        <b-pagination align="center"
                      size="md"
                      :total-rows="totalRecords"
                      v-model="pageNumber"
                      :per-page="pageSize"
                      @input="handlePagenationInput" />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
//import DataListCSV from '@/components/DataListCSV.vue'


import PageSize from '@/components/PageSize.vue'
import SearchForm from '@/components/SearchForm.vue'

import { searchInputs } from '@/ui.config/inputs/formUserSearchInputs'
import { formUserCols } from '@/ui.config/cols/formUserCols'

import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name:'FormUser',
    mixins: [

    ],
    components: {
        PageHeader,
        DataList,
        //'data-list-csv': DataListCSV,
        PageSize,
        SearchForm,
        Loading,
        OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Form - Users',
            },

            searchInputs: searchInputs,
            formUserCols: formUserCols,

            searchPayload: null,
            orderBy: 'DateCreated',
            sortDirection: 'DESC',

            selectedOrderBy: null,

            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'EmailAddress',
                    label: 'Email Address'
                },
                {
                    id: 1,
                    key: 'DateCreated',
                    label: 'Date Created'
                },
                {
                    id: 2,
                    key: 'LastSignedInDate',
                    label: 'Last Signed In Date'
                }
            ],
        }
    },
    beforeMount() {
        this.fetchFormUserListPagenated({})
        this.fetchResellers()
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        pageNumber: {
            get() {
                return this.$store.getters.pageNumber
            },
            set(value) {
                this.$store.commit('setPageNumber', value)
            }
        },
        totalRecords() {
            return this.$store.getters.totalRecords
        },
        pageSize: {
            get() {
                return this.$store.getters.pageSize
            },
            set(value) {
                this.$store.commit('setPageSize', value)
            }
        },
        formUserList() {
            return this.$store.getters.formUserList
        },
        searchInputsEx() {
            var { resellers, searchInputs } = this

            if (searchInputs && searchInputs.length > 0) {
                if (resellers) {
                    searchInputs[0].options = resellers
                }
            }
            return searchInputs
        },
        resellers() {
            return this.$store.getters.resellers
        },
    },
    methods: {
        ...mapActions([
            'fetchFormUserListPagenated',
            'fetchResellers'
        ]),
        handlePagenationInput(payload) {
            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
            this.formUserSearch(criteria, payload)
        },
        handleOrderByClick(payload) {
            let { orderBy, direction } = payload
            if ((typeof (orderBy) != 'undefined' && orderBy != null) &&
                (typeof (orderBy) != 'undefined' && orderBy != null)) {

                this.orderBy = orderBy.key
                this.sortDirection = direction
                this.handleSearchClick(this.searchPayload)
            }
        },
        handleSearchClick(payload) {
            if (payload != null) {
                this.searchPayload = payload

                let criteria = this.buildSearchValues(payload)

                this.formUserSearch(criteria, 1)
            } else {
                this.formUserSearch(null, 1)
            }
        },
        handleClearClick() {

            this.claimsSearch(null, 1)
        },
        buildSearchValues(payload) {
            if (payload != null) {
                let { reseller, emailAddress } = payload

                let criteria = {
                    resellerId: reseller ? reseller.id : null,
                    emailAddress: emailAddress
                }

                return criteria
            } else {
                return null
            }
        },
        buildSearchCriteria(searchValues, pageNumber) {
            let ordering = {
                orderBy: this.orderBy,
                sortDirection: this.sortDirection
            }

            let pages = {
                pageSize: this.pageSize,
                pageNumber: pageNumber
            }

            let criteria = {
                ...searchValues,
                ...ordering,
                ...pages
            }

            return criteria
        },
        formUserSearch(searchValues, pageNumber) {
            //this.clearClaimsList()

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)

            this.fetchFormUserListPagenated(criteria)
        }
    }
}
</script>

<style>
</style>
